import "./StatusFormatter.css";
import * as React from "react";

export const StatusFormatter = (props: { cssClass: string, label: string, title?: string }) => {
    return <div className={`import-status-formatter ${props.cssClass} align-center`} title={props.title}>
        <div className="dot-container"><div className="dot" /></div>
        <span className="label">{props.label}</span>
    </div>
}